<template>
  <jt-card-default
    :shouldShowSelectMonth="true"
    :cardSelectType="0"
    :shouldShowFullscreen="false"
    @change="onChangeSelectDate"
  >
    <div v-if="isLoading" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>

    <br />
    <br />

    <q-markup-table separator="none" class="bg-blue-grey-2">
      <thead>
        <tr>
          <th colspan="3">
            <div class="text-h6">{{this.$gettext('DASHBOARD_COMMERCIAL')}}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th colspan="3">
            <hr />
          </th>
        </tr>
        <tr>
          <td>
            <jt-info-card
              iconName="people"
              accentColor="blue"
              label="DASHBOARD_COMMERCIAL_ACTIVATE_CLIENTS_AMOUNT"
              :shouldTranslateLabel="true"
              :shouldFormatValue="true"
              nmInterface="entrance.hql"
              nmGrid="activateClients"
              nmGridProperty="counts"
            />
          </td>
          <td>
            <jt-info-card
              ref="customersAttendedMonth"
              iconName="mdi-account-multiple-check"
              accentColor="purple"
              label="DASHBOARD_COMMERCIAL_CUSTOMERS_ATTENDED"
              :shouldTranslateLabel="true"
              :shouldFormatValue="true"
              nmInterface="entrance.hql"
              nmGrid="customersAttendedMonth"
              nmGridProperty="counts"
              :parameters="{ month: monthSelect, year: yearSelect }"
            />
          </td>
        </tr>

        <tr>
          <td>
            <jt-info-card
              ref="expiringContracts"
              iconName="mdi-calendar-alert"
              accentColor="red"
              label="DASHBOARD_COMMERCIAL_EXPIRING_CONTRACTS"
              :shouldTranslateLabel="true"
              :shouldFormatValue="true"
              nmInterface="entrance.hql"
              nmGrid="expiringContracts"
              nmGridProperty="counts"
              :parameters="{ month: monthSelect, year: yearSelect }"
            />
          </td>
          <td>
            <jt-info-card
              ref="newCustomersMonth"
              iconName="mdi-account-multiple-plus"
              accentColor="green"
              label="DASHBOARD_COMMERCIAL_NEW_CUSTOMERS_MONTH"
              :shouldTranslateLabel="true"
              :shouldFormatValue="true"
              nmInterface="entrance.hql"
              nmGrid="newCustomersMonth"
              nmGridProperty="counts"
              :parameters="{ month: monthSelect, year: yearSelect }"
            />
          </td>
        </tr>
        <tr>
          <th colspan="3">
            <hr />
          </th>
        </tr>
        <tr>
            <th colspan="3">
              <div class="text-h7">{{this.$gettext('DASHBOARD_COMMERCIAL_CHECK_AVG_PRICE')}}</div>
            </th>
         </tr>

        <tr>
          <td colspan="3">

              <q-select color="teal"  bg-color="white" outlined
                v-model="model"
                use-input
                hide-selected
                label="Resíduo"
                fill-input
                input-debounce="0"
                :options="options"
                @filter="filterFn"
                :hint="((model!=null && model.value!=undefined) ? 'R$'+ model.value: '')"
                style="padding-bottom: 32px"
                behavior="dialog"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      No results
                    </q-item-section>
                  </q-item>
                </template>

              </q-select>
          </td>
        </tr>
      </tbody>
    </q-markup-table>
  </jt-card-default>
</template>
<script>
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import JtInfoCard from 'src/components/dashboard/dashboard-card-components/JtInfoCard.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'

@Component({
  name: 'Commercial',
  components: {
    JtCardDefault,
    JtInfoCard
  }
})
export default class Commercial extends Vue {
  isLoading = false;

  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };

  monthSelect;
  yearSelect;
  residuePrice;
  stringOptions;
  model = null;
  options;

  setZeros () {
    this.rowsMonthYear = [
      {
        month: 0,
        year: 0
      },
      {
        name: 'Projetado',
        month: 0,
        year: 0
      },
      {
        name: 'Tendência',
        month: 0,
        year: 0
      },
      {
        name: 'Var. Tend/Proj',
        month: 0,
        year: 0
      }
    ]
  }

  created () {
    this.onChangeSelectDate(this.currentDate)
  }

  filterFn (val, update, abort) {
    update(() => {
      const needle = val.toLowerCase()
      this.options = this.stringOptions.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      this.model = needle
    })
  }

  async getResiduePrice (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'residuePrice',
        month: date.month,
        year: date.year
      }
    )

    const options = registros.map((registro) => {
      return {
        label: registro.name + '  -  ' + registro.value,
        value: registro.value
      }
    })

    return options
  }

  async onChangeSelectDate (date) {
    this.isLoading = true
    this.monthSelect = date.month
    this.yearSelect = date.year

    this.stringOptions = await this.getResiduePrice(date)
    this.options = this.stringOptions

    this.$nextTick(() => {
      this.$refs.customersAttendedMonth.reload()
      this.$refs.newCustomersMonth.reload()
      this.$refs.expiringContracts.reload()
    })

    setTimeout(() => {
      this.isLoading = false
    }, 500)
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

.q-chip {
  max-width: 180px;
}
</style>
